export default __webpack_public_path__ + "static/media/moore-foundation-logo.cf4937ae.png";